export const CURRENCY_TO_COUNTRY_MAP: Record<string, string> = {
  TND: 'Tunisia',
  DZD: 'Algeria',
  MAD: 'Morocco',
  ZAR: 'South Africa',
  XOF: 'Senegal'
}

export const CURRENCY_TO_COUNTRY_CODE_MAP: Record<string, string> = {
  TND: 'TN',
  DZD: 'DZ',
  MAD: 'MA',
  ZAR: 'ZA',
  XOF: 'SN'
}

const cleanCurrencyCode = (currencyCode: string): string => {
  try {
    if (currencyCode.startsWith('"') && currencyCode.endsWith('"')) {
      return JSON.parse(currencyCode)
    }
  } catch (error) {
    console.warn(error)
  }
  return currencyCode
}

export const getCountryFromCurrency = (
  currencyCode: string | null
): string | null => {
  if (!currencyCode) return null
  return CURRENCY_TO_COUNTRY_MAP[cleanCurrencyCode(currencyCode)] || null
}

export const getCountryCodeFromCurrency = (
  currencyCode: string | null
): string | null => {
  if (!currencyCode) return null
  return CURRENCY_TO_COUNTRY_CODE_MAP[cleanCurrencyCode(currencyCode)] || null
}

export const TARGET_COUNTRIES = Object.values(CURRENCY_TO_COUNTRY_MAP)
